export const devicesData = [
    { title: "Log out of all devices", description: "Log out of all other active sessions on other devices besides this one." }
  ];